import { Controller } from "@hotwired/stimulus";

const COOKIE_NAME = "sidebar:state";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 7; // 7 days

// Manages admin sidebar: desktop collapse, mobile slide-over, cookie persistence.
export default class extends Controller<HTMLElement> {
  static targets = ["mobileMenu", "mobileBackdrop", "toggleButton"];

  declare hasMobileMenuTarget: boolean;
  declare mobileMenuTarget: HTMLElement;
  declare hasMobileBackdropTarget: boolean;
  declare mobileBackdropTarget: HTMLElement;
  declare hasToggleButtonTarget: boolean;
  declare toggleButtonTarget: HTMLElement;

  private isMobile(): boolean {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  toggle() {
    if (this.isMobile()) {
      this.toggleMobile();
    } else {
      this.toggleDesktop();
    }
  }

  private toggleDesktop() {
    const open = this.element.dataset.state !== "expanded";
    this.element.dataset.state = open ? "expanded" : "collapsed";
    document.cookie = `${COOKIE_NAME}=${open}; path=/; max-age=${COOKIE_MAX_AGE}`;
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.setAttribute("aria-expanded", String(open));
    }
  }

  toggleMobile() {
    if (!this.hasMobileMenuTarget) {
      return;
    }

    const value = this.mobileMenuTarget.dataset.mobileOpen !== "true" ? "true" : "false";
    this.mobileMenuTarget.dataset.mobileOpen = value;
    if (this.hasMobileBackdropTarget) {
      this.mobileBackdropTarget.dataset.mobileOpen = value;
    }
  }
}
